import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'start.learning': {
    id: 'start.learning',
    defaultMessage: 'Start learning',
    description: 'Header text for logistration MFE pages',
  },
  'with.site.name': {
    id: 'with.site.name',
    defaultMessage: 'with {siteName}',
    description: 'Header text with site name for logistration MFE pages',
  },
  'authn.brand.learn': {
    id: 'authn.brand.learn',
    defaultMessage: 'Learn',
    description: 'First word in the authentication page brand message',
  },
  'authn.brand.practice': {
    id: 'authn.brand.practice',
    defaultMessage: 'Practice',
    description: 'Second word in the authentication page brand message',
  },
  'authn.brand.connect': {
    id: 'authn.brand.connect',
    defaultMessage: 'Connect',
    description: 'Third word in the authentication page brand message',
  },
  'authn.brand.tagline': {
    id: 'authn.brand.tagline',
    defaultMessage: 'Centuries of wisdom, thoughtfully brought to your learning journey.',
    description: 'Tagline shown on authentication pages',
  },
});

export default messages;
